import React, { Component } from 'react';
import styled from 'styled-components';

const Header = styled.div`
  width: 100%;

  ${'' /* text-align: center; */}
  border: 1px solid lightgrey;
  ${'' /* border-top-left-radius: 5px;
  border-top-right-radius: 5px; */}
  &:hover {
    border-top: 2px solid #f76636;
  }
  height: ${props => {
    return props.height + 'px';
    }}
`

const Text = styled.span`
  vertical-align: middle;
`

class EmbedHeader extends Component {
  render() {
    return (
      <Header height={this.props.height}>
        <img alt='logo' src={this.props.imgsrc} height='16' style={{paddingLeft: '5px', paddingTop: '0'}}/>
        <Text>
          {this.props.text}
        </Text>
      </Header>
    )
  }
}

export default EmbedHeader;



// WEBPACK FOOTER //
// ./src/_EmbedHeader.js